import { BlackPause, CircleGrey, ConfirmSolid, IcoConformeDaValidare, RejectSolid } from '@icons';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

interface TotalResumeChecklistCellRendererProps {
	value: unknown;
	data: Record<
		string,
		{
			key: string;
			checkliststatus: {
				color: string;
			};
			sampled?: boolean;
		}
	>;
}

const TotalResumeChecklistCellRenderer: React.FC<TotalResumeChecklistCellRendererProps> = (params) => {
	// params.value = reportable
	// VERDE conforme -> tutti verdi (anche green_white e green_white_settled) (nessuna risposta N.D. o NO) BASTA IL FLAG
	// ROSSO non conforme -> sia rossi che gialli (almeno una risposta N.D. o NO) BASTA IL FLAG

	let icon;
	let firstMessage = '';
	// let secondMessage = '';
	const arrayEntities = ['tender', 'frameworkContract', 'contract', 'invoice', 'payment', 'timesheet'];

	if (params.value && params.data) {
		const hasSomeGreenWhiteChecklist = arrayEntities.every(
			(entity) => params.data[entity]?.checkliststatus && params.data[entity]?.checkliststatus.color === 'green_white',
		);
		icon = <ConfirmSolid width={20} height={20} />;
		firstMessage = 'conforme';

		if (hasSomeGreenWhiteChecklist) {
			icon = <IcoConformeDaValidare width={20} height={20} />;
			firstMessage = 'conforme - da validare';
		}
		// firstMessage += hasSomeGreenWhiteChecklist ? ' - da validare' : '';
		// secondMessage = 'visibile in rendicontazione';
	} else {
		const hasSomeRedChecklist = arrayEntities.some(
			(entity) => params.data[entity]?.checkliststatus && params.data[entity]?.checkliststatus.color === 'red',
		);

		const hasAllWhiteChecklist = arrayEntities.every(
			(entity) => params.data[entity]?.checkliststatus && params.data[entity]?.checkliststatus.color === 'white',
		);

		const hasSomeWhiteChecklist = arrayEntities.some(
			(entity) => params.data[entity]?.checkliststatus && params.data[entity]?.checkliststatus.color === 'white',
		);

		if (hasSomeRedChecklist) {
			icon = <RejectSolid width={20} height={20} />;
			firstMessage = 'non conforme';
			// secondMessage = 'non visibile in rendicontazione';
		} else {
			if (hasAllWhiteChecklist) {
				icon = <CircleGrey width={20} height={20} />;
				firstMessage = 'da controllare';
				// secondMessage = 'inizia le azioni di controllo';
			} else if (hasSomeWhiteChecklist) {
				icon = <BlackPause width={20} height={20} />;
				firstMessage = 'da completare';
				// secondMessage = 'controlla tutti gli elementi';
			} else {
				icon = <RejectSolid width={20} height={20} />;
				firstMessage = 'non conforme';
				// secondMessage = 'non visibile in rendicontazione';
			}
		}
	}
	const secondMessage = !params.data.sampled ? 'singolo controllo' : 'post-campionamento';

	return (
		<Row className="align-items-center justify-content-center h-100">
			<Col className="col-auto text-center">{icon}</Col>
			<Col>
				<span className="f-700 d-block">{firstMessage}</span>
				<span>{secondMessage}</span>
			</Col>
		</Row>
	);
};

export default TotalResumeChecklistCellRenderer;
